import React, {useEffect, useState} from 'react';
import { useVisibilityChange } from '../../../Services/helpers';
import Build from '../../../Data/Build';
import Alert from '../../../Components/Alert';

const UpdatesAvailable = () => {
    const [lastCheck, setLastCheck] = useState(null);
    const [outOfDate, setOutOfDate] = useState(false);

    useVisibilityChange(() => {
        if (updateDue(lastCheck) === false) {
            return
        }

        checkForUpdates(setOutOfDate, setLastCheck);
    }, true);

    useEffect(() => {
        if (updateDue(lastCheck) === false) {
            return
        }

        checkForUpdates(setOutOfDate, setLastCheck);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (outOfDate) {
        return <Alert theme="brand"
            icon="PartyHorn"
            title="Update available"
            message="There's a new version of the app available. Tap to update."
            onClick={() => window.location.reload(true)}
        />
    }

    return null;
}

const timestamp = () => {
    return Math.round(new Date().getTime() / 1000);
}

const updateDue = (lastCheck) => {
    return lastCheck < (timestamp() - (60 * 5));
}

const checkForUpdates = (setOutOfDate, setLastCheck) => {
    // console.log('checkForUpdates')
    fetch('/build.txt').then(result => {
        result.text().then(serverBuild => {
            setOutOfDate(serverBuild.trim() > Build);
            setLastCheck(timestamp());
        })
    })
}


export default UpdatesAvailable;
